import { applyDecorators } from '@nestjs/common';
import { ApiProperty, ApiPropertyOptional, ApiPropertyOptions } from '@nestjs/swagger';
import { IsByteLength, IsHexadecimal, IsOptional } from 'class-validator';
import { INVALID_TOKEN, INVALID_TOKEN_LENGTH } from '../constants';
import { BaseDecoratorOptions } from '../types';

type PropertyHashParams = {
  length?: number;
} & BaseDecoratorOptions<string>;


export function ApiPropertyHash({ isOptional, length, ...options }: PropertyHashParams): PropertyDecorator {
  const propertyOptions: ApiPropertyOptions = {
    type: 'string',
    example: '8743b52063cd84097a65d1633f5c74f5',
    ...options,
  };

  return applyDecorators(
    ...(isOptional ? [IsOptional(), ApiPropertyOptional(propertyOptions)] : [ApiProperty(propertyOptions)]),
    IsHexadecimal({ message: INVALID_TOKEN }),
    ...((length)
      ? [IsByteLength(length, length, { message: INVALID_TOKEN_LENGTH, context: { length } })]
      : []),
  );
}
